<div class="wrap-container" (click)="closeModal()">
  <button mat-icon-button aria-label="close dialog" mat-dialog-close class="close-button">
    <app-icon>close</app-icon>
  </button>
  @if (files.length && files.length > 1) {
    <button (click)="changeCurrentFile($event, -1)" mat-icon-button class="nav-button left-button">
      <app-icon>keyboard_arrow_left</app-icon>
    </button>

    <button (click)="changeCurrentFile($event, 1)" mat-icon-button class="nav-button right-button">
      <app-icon>keyboard_arrow_right</app-icon>
    </button>
  }

  <div class="index-container">{{ currentIndex + 1 }}/{{ files.length }}</div>

  @if (currentFile?.type === 'image') {
    @if (!!currentFile?.url) {
      <div class="zoom-controls">
        <button
          type="button"
          mat-icon-button
          (click)="zoomOut(); $event.stopPropagation()"
          [disabled]="scale <= minScale"
        >
          <app-icon>remove</app-icon>
        </button>
        <span class="zoom-level">{{ scale * 100 | number: '1.0-0' }}%</span>
        <button
          type="button"
          mat-icon-button
          (click)="zoomIn(); $event.stopPropagation()"
          [disabled]="scale >= maxScale"
        >
          <app-icon>add</app-icon>
        </button>
        <button type="button" mat-icon-button (click)="resetZoom(); $event.stopPropagation()" [disabled]="scale === 1">
          <app-icon>restart_alt</app-icon>
        </button>
      </div>
    }
  }

  <div
    (click)="$event.stopPropagation()"
    class="content"
    [class.content-document]="currentFile?.type === 'document'"
  >
    @if (currentFile.isLoading) {
      <mat-spinner class="loader"></mat-spinner>
    }
    @if (!!currentFile?.url && currentFile.type === 'image') {
      <img
        [src]="currentFile.url"
        (load)="fileLoaded()"
        (wheel)="onWheel($event)"
        (dblclick)="onImageDoubleClick($event)"
        (mousedown)="onMouseDown($event)"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (touchend)="onTouchEnd($event)"
        [style.transform]="getImageTransform()"
        [style.cursor]="getImageCursor()"
        class="zoomable-image"
        alt
      />
    }
    @if (!!currentFile?.url && currentFile.type === 'video') {
      <video [src]="currentFile.url" controls></video>
    }
    @if (!!currentFile?.url && currentFile.type === 'audio') {
      <app-audio-player-v2 [title]="currentFile.name || ''" [src]="currentFile.url"></app-audio-player-v2>
    }
    @if (!!currentFile?.url && currentFile.type === 'document') {
      <ngx-doc-viewer
        [ngClass]="{ 'd-none': currentFile.isLoading }"
        [url]="currentFile.url"
        viewer="google"
        class="doc-viewer"
        (loaded)="fileLoaded()"
      ></ngx-doc-viewer>
    }
  </div>
</div>
